import { string, date, object, SchemaOf } from 'yup';
import dayjs from 'dayjs';

import { REQUIRED_FIELD, MAX_STRING_LENGTH_YUP_TEMPLATE, DATE_IN_PAST, 
  DATE_AFTER_CONTRACT_END_PLUS_1 } from '@/config/text.const';

export const errorMessages = {
  NO_FURTHER_BILLING_AFTER_TERMINATION: 'Can\'t be after "Termination Date"',
  NO_FURTHER_BILLING_AFTER_CONTRACT_END: DATE_AFTER_CONTRACT_END_PLUS_1
};

export type TerminateContractLinesFormFields = {
  reasonCode: string;
  terminationDate: Date;
  comment: string;
};

export const validationSchema: SchemaOf<TerminateContractLinesFormFields> = object().shape({
  reasonCode: string()
    .required(REQUIRED_FIELD),

  terminationDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), DATE_IN_PAST)
    .required(REQUIRED_FIELD)
    .test((value, { options, createError }) => {
      const contractRenewableTerm = options?.context?.contractRenewableTerm ?? null;
      const contractEndDate = dayjs(options?.context?.contractEndDate ?? null);
      const selectedTerminationDate = dayjs(value ?? null);

      if (!contractRenewableTerm && selectedTerminationDate.isAfter(contractEndDate.add(1, 'day'), 'date')) {
        return createError({
          message: errorMessages.NO_FURTHER_BILLING_AFTER_CONTRACT_END
        });
      }
      return true;
    }),

  comment: string()
    .max(100, MAX_STRING_LENGTH_YUP_TEMPLATE)
    .required(REQUIRED_FIELD),
});
